import { DatePicker, InputNumber } from 'antd';
import { debounce } from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setBalanceOfferFinancial,
  setCollectionOfferFinancial,
  setPaymentOfferFinancial,
} from '../../contextRedux/ReportOfferFinancial/ReportOfferFinancialStore';
import ReportOfferFinancialService from '../../services/reportOfferFinancial/ReportOfferFinancialService';
import { RootState } from '../../store';
import ChartBalance from './FinancialGantt/ChartBalance';
import ChartCollection from './FinancialGantt/ChartCollection';
import ChartPayment from './FinancialGantt/ChartPayment';

const Report: React.FC = () => {
  const dispatch = useDispatch();

  const reduxFinancial = useSelector((state: RootState) => state.store.reprotOfferFinancial);

  const [month, setMonth] = useState<number | null>(moment().month() + 1);
  const [year, setYear] = useState<number | null>(moment().year());
  const [balance, setBalance] = useState<number | null>(null);

  const fetchFinancialData = (month: number | null, year: number | null, bankBalance: number | null) => {
    if (month !== null && year !== null) {
      ReportOfferFinancialService.collectionOfferFinancial({
        month: month,
        year: year,
      }).then((data) => {
        dispatch(setCollectionOfferFinancial(data?.response));
      });

      ReportOfferFinancialService.paymentOfferFinancial({
        month: month,
        year: year,
      }).then((data) => {
        dispatch(setPaymentOfferFinancial(data?.response));
      });

      ReportOfferFinancialService.balanceOfferFinancial({
        month: month,
        year: year,
        bankBalance: bankBalance!,
      }).then((data) => {
        dispatch(setBalanceOfferFinancial(data?.response));
      });
    }
  };

  const debouncedFetchFinancialData = useCallback(
    debounce((month: number | null, year: number | null, bankBalance: number | null) => {
      fetchFinancialData(month, year, bankBalance);
    }, 500),
    []
  );

  useEffect(() => {
    debouncedFetchFinancialData(month, year, balance);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [month, year, balance]);

  const handleBalanceChange = (value: number | null) => {
    setBalance(value);
  };

  const handleDateChange = (date: moment.Moment | null) => {
    if (date) {
      setMonth(date.month() + 1);
      setYear(date.year());
    } else {
      setMonth(null);
      setYear(null);
    }
  };

  const selectedMonthDate = month !== null && year !== null ? new Date(year, month - 1) : null;

  return (
    <>
      <h1>Financiar Offer</h1>
      <div style={{ width: '30%', marginTop: '16px', marginBottom: '16px' }}>
        <DatePicker
          defaultValue={moment()}
          onChange={handleDateChange}
          picker='month'
          style={{ marginBottom: '16px', width: '100%' }}
          allowClear
        />
        <InputNumber
          min={0}
          value={balance}
          onChange={handleBalanceChange}
          style={{ marginBottom: '16px', width: '100%' }}
        />
      </div>
      <h2>Incasari</h2>
      {selectedMonthDate && (
        <ChartCollection contracts={reduxFinancial.collectionOfferFinancial} selectedMonth={selectedMonthDate} />
      )}
      <h2>Plati</h2>
      {selectedMonthDate && (
        <ChartPayment contracts={reduxFinancial.paymentOfferFinancial} selectedMonth={selectedMonthDate} />
      )}
      <h2>Sold</h2>
      {selectedMonthDate && (
        <ChartBalance
          contracts={reduxFinancial.balanceOfferFinancial}
          selectedMonth={selectedMonthDate}
          bankBalance={balance}
        />
      )}
    </>
  );
};

export default Report;
